import { useState } from 'react';
import { ResetProgressDialog } from './ResetProgressDialog';

/**
 * The player detail's "Reset progress" quick action (card #251): a button that opens {@link ResetProgressDialog}. It fits the
 * Quick actions bar through `QuickActionsBar`'s `extraActions` (styled like the bar's own buttons).
 */
export function ResetProgressButton({ playerId }: { playerId: string }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="rounded border-2 border-ink px-3 py-1 text-left hover:bg-caption/40"
      >
        <span className="block text-sm font-semibold">Reset progress</span>
        <span className="block text-xs text-bruise">Replay story, bosses, missions, hunts…</span>
      </button>
      {open && <ResetProgressDialog playerId={playerId} onClose={() => setOpen(false)} />}
    </>
  );
}
